module.exports = __webpack_public_path__ + "img/logo-shiba888.e51a2072.png";